'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.consentToCommunicateFailed = exports.consentToCommunicateSucceeded = exports.clickedConsentToCommunicate = undefined;
exports.visitorConsentsToCommunicate = visitorConsentsToCommunicate;

var _reduxActions = require('redux-actions');

var _ActionTypes = require('../constants/ActionTypes');

var _ConsentToCommunicateClient = require('../client/ConsentToCommunicateClient');

var _getSessionId = require('../../selectors/widgetDataSelectors/getSessionId');

var clickedConsentToCommunicate = exports.clickedConsentToCommunicate = (0, _reduxActions.createAction)(_ActionTypes.CONSENT_TO_COMMUNICATE);
var consentToCommunicateSucceeded = exports.consentToCommunicateSucceeded = (0, _reduxActions.createAction)(_ActionTypes.CONSENT_TO_COMMUNICATE_SUCCEEDED);
var consentToCommunicateFailed = exports.consentToCommunicateFailed = (0, _reduxActions.createAction)(_ActionTypes.CONSENT_TO_COMMUNICATE_FAILED, function (error) {
  return { error: error };
});

function visitorConsentsToCommunicate() {
  var consent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (consent) {
    return function (dispatch, getState) {
      var sessionId = (0, _getSessionId.getSessionId)(getState());

      dispatch(clickedConsentToCommunicate());

      var successCb = function successCb() {
        dispatch(consentToCommunicateSucceeded());
      };

      var failureCb = function failureCb(error) {
        dispatch(consentToCommunicateFailed(error));
      };

      (0, _ConsentToCommunicateClient.sendConsentToCommunicate)({ sessionId: sessionId }).then(successCb, failureCb).done();
    };
  }
  return null;
}


//////////////////
// WEBPACK FOOTER
// ./js/gdpr/actions/visitorConsentsToCommunicate.js
// module id = 520
// module chunks = 2 3